import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// Resolve only against the locations already authorized and loaded for this user.
export default function useSettingsLocation({ enabled, ready, clients, selectedId, onSelect }) {
  const [params, setParams] = useSearchParams();
  const requestedId = params.get('location');

  useEffect(() => {
    if (!enabled || !ready) return;
    if (clients.length === 0) {
      if (selectedId) onSelect(null);
      return;
    }
    const location = clients.find((client) => client.id === requestedId) || clients[0];
    if (location.id !== selectedId) onSelect(location);
    if (requestedId !== location.id) {
      const next = new URLSearchParams(params);
      next.set('location', location.id);
      setParams(next, { replace: true });
    }
  }, [enabled, ready, clients, requestedId, selectedId, onSelect, params, setParams]);
}
